import { nextTick } from "../Runtime";
/**
 * Preloader implementation to load files before they are actually needed.
 *
 * @public
 */
export class Preloader {
    constructor() {
        this.alreadyLoadedSources = [];
        this.loadScheduled = false;
        this.sources = [];
    }
    preload(source, priority, sourceType) {
        this.sources.push({
            source,
            priority,
            sourceType: sourceType || "script" /* SCRIPT */
        });
        if (!this.loadScheduled) {
            /**
             * de-duplication at nextTick, because of the de-duplication complexity (for loop in for loop)
             */
            nextTick(this.doPreload.bind(this));
            this.loadScheduled = true;
        }
    }
    uniqueArrayReducer(elem) {
        return (result, next) => result || next.source === elem.source;
    }
    uniqueArray(array) {
        return array.filter((elem, pos, arr) => {
            const reducerFn = this.uniqueArrayReducer(elem);
            // check if there was already an source like the current
            const duplicateFound = arr.slice(0, pos).reduce(reducerFn, false);
            const loadedEarlier = this.alreadyLoadedSources.reduce(reducerFn, false);
            return !duplicateFound && !loadedEarlier;
        });
    }
    doPreload() {
        if (!document.head) {
            throw new Error("document must contain a head-element to do preloading");
        }
        // filter duplicates
        const uniqueSources = this.uniqueArray(this.sources);
        // reset buffered sources for new preloading requests
        this.sources = [];
        this.loadScheduled = false;
        this.alreadyLoadedSources.push(...uniqueSources);
        const fragment = uniqueSources
            .map((value) => {
            // create the link Element for each source
            const res = document.createElement("link");
            res.rel = value.priority;
            res.as = value.sourceType;
            res.href = value.source;
            return res;
        })
            .reduce((initial, value) => {
            // append every link element to the document fragment to reduce DOM manipulations
            initial.appendChild(value);
            return initial;
        }, document.createDocumentFragment());
        // start preloading with only one DOM operation.
        document.head.appendChild(fragment);
    }
}
//# sourceMappingURL=Preloader.js.map